<template>
  <div>
    <!-- Image at the top -->
    <div class="rightContainer">
      <!-- <div class="cards" style="margin-bottom: 35px">
      <div class="card">
        <div class="icon one">
          <svg
            width="28"
            height="27"
            viewBox="0 0 28 27"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M14 21.1875L6.28496 25.2437L7.75871 16.6525L1.51746 10.5688L10.1425 9.31625L14 1.5L17.8575 9.31625L26.4825 10.5688L20.2412 16.6525L21.715 25.2437L14 21.1875Z"
              stroke="#202842"
              stroke-width="1.875"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <div class="cont">
          <label>Average Votes</label>
          <h3>{{ votes.average_votes }}</h3>
        </div>
      </div>

      <div class="card">
        <div class="icon two">
          <svg
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="3.75"
              y="5"
              width="22.5"
              height="5"
              rx="2.5"
              stroke="#202842"
              stroke-width="1.875"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M6.25 10V22.5C6.25 23.8807 7.36929 25 8.75 25H21.25C22.6307 25 23.75 23.8807 23.75 22.5V10"
              stroke="#202842"
              stroke-width="1.875"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M12.5 15H17.5"
              stroke="#202842"
              stroke-width="1.875"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <div class="cont">
          <label>Total votes</label>
          <h3>{{ votes.total_votes }}</h3>
        </div>
      </div>
      <div class="card">
        <div class="icon three">
          <svg
            width="30"
            height="30"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="w-6 h-6"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M16.5 18.75h-9m9 0a3 3 0 013 3h-15a3 3 0 013-3m9 0v-3.375c0-.621-.503-1.125-1.125-1.125h-.871M7.5 18.75v-3.375c0-.621.504-1.125 1.125-1.125h.872m5.007 0H9.497m5.007 0a7.454 7.454 0 01-.982-3.172M9.497 14.25a7.454 7.454 0 00.981-3.172M5.25 4.236c-.982.143-1.954.317-2.916.52A6.003 6.003 0 007.73 9.728M5.25 4.236V4.5c0 2.108.966 3.99 2.48 5.228M5.25 4.236V2.721C7.456 2.41 9.71 2.25 12 2.25c2.291 0 4.545.16 6.75.47v1.516M7.73 9.728a6.726 6.726 0 002.748 1.35m8.272-6.842V4.5c0 2.108-.966 3.99-2.48 5.228m2.48-5.492a46.32 46.32 0 012.916.52 6.003 6.003 0 01-5.395 4.972m0 0a6.726 6.726 0 01-2.749 1.35m0 0a6.772 6.772 0 01-3.044 0"
            />
          </svg>
        </div>
        <div class="cont">
          <label>Lead Candidate</label>
          <h3
            :style="{
              fontWeight: '300',
              fontSize: displayLeadCandidate.length > 20 ? '0.6em' : displayLeadCandidate.length > 10 ? '0.7em' : '0.8em'
            }"
          >
            {{ displayLeadCandidate }}
          </h3>

        </div>
      </div>
    </div> -->

      <div class="card-one">
        <h3>Live Votes</h3>

        <div v-for="(vote, index) in votes.nominees" class="container" :key="index">


          <div class="topLabels">
            <label style="display: flex; align-items: center;">
              <img src="https://client.gig.co.ke/eventpics/cZWdjw4rB1.jpg"
               alt="Nominee Image"
                style="width: 200px; height: 200px; object-fit: cover; margin-right: 30px; border-radius: 20px; border: 2px solid #ccc;" />

              <div>
                <div>
                  <span>{{ vote.name }} </span> <br>
                  <span style="font-size: 0.8em;">{{ vote.country }}</span>
                </div>
                <!-- <div style="margin-top: 5px;">
                <span style="font-size: 0.8em;">{{ vote.description }}: {{ vote.company }}</span>
              </div> -->
                <!-- <div style="margin-top: 5px; display: flex; align-items: center;">
                  <img :src="getCountryFlag(vote.country)" alt="Country Flag"
                    style="width: 30px; height: 20px; object-fit: cover; margin-right: 5px;" />
                  <span style="font-size: 0.6em;">{{ vote.country }}</span>

                </div> -->
              </div>



            </label>

            <!-- Votes Information -->
            <label>{{ vote.votes }} votes</label>
          </div>
          <div class="progress" style="margin-top: 15px;">
            <transition appear @before-appear="beforeEnter" @after-appear="enter">
              <div class="bar one" :style="{ width: vote.percentage + '%' }"></div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { htmlEntity } from "../htmlEntityMixin";

import { store } from "@/store/store.js";
import Vue from "vue";
// import RegisterPlayer from "../components/general/RegisterPlayer";
// import Leaderboard from "../components/result/Leaderboard";
import axios from "axios";
import qs from "qs";
// const Leaderboard = () => import("../components/result/Leaderboard");
export default {
  mixins: [htmlEntity],
  components: {},
  data() {
    return {
      playImg: require("@/assets/play.svg"),
      progress: 20,
      show: false,
      votes: {
        total_votes: 0,
        lead_votes: 0,
        average_votes: 0,
        nominees:[],
        lead_candidates: []
      },
    };
  },
  mounted() {
    let context = this;
    Echo.channel("tuni-clear-abyss").listen(".new_vote_added", (datas) => {
      console.log(datas);
      let data = datas.data;
      context.votes = data;
    });

    this.fetchCandidates();
   
  },
  computed: {
    displayLeadCandidate() {
      if (this.votes.lead_candidates.length > 1) {
        return 'Tie'; // Display 'Tie' if there are multiple lead candidates
      } else if (this.votes.lead_candidates.length === 1) {
        return this.votes.lead_candidates[0].company;
      } else {
        return 'No Lead Candidate';
      }
    },
  },
  methods: {
    beforeEnter(el) {
      // el.style.width = 0;
    },
    enter(el) {
      // el.style.width = `${this.percentage}%`
      el.style.transition = `width 1s linear`;
    },
    countryCodes() {
      return {
        "Kenya": "ke",
        "United States": "us",
        "Germany": "de",
        "United Kingdom": "gb",
        "Nigeria": "ng",
        "Ghana": "gh",
        "South Africa": "za",
        "Cameroon": "cm",
        "Senegal": "sn",
        "Rwanda": "rw",
        "Togo": "tg",
        "Congo, The Democratic Republic of The": "cd",
        "Guinea": "gn",
        "Morocco": "ma",
        "Angola": "ao",
        "Malawi": "mw",
        "Sierra Leone": "sl",
        "Zimbabwe": "zw",
        "Cote D'Ivoire": "ci",
        "Madagascar": "mg",
        "South Sudan": "ss",
        "Mozambique": "mz",

        // Add more country mappings here
      };
    },

    getCountryFlag(country) {
      const countryCode = this.countryCodes()[country] || 'unknown';
      if (countryCode !== 'unknown') {
        return `https://flagcdn.com/256x192/${countryCode}.png`;
      } else {
        return ""; // Return an empty string if country code is not found
      }
    },
    fetchCandidates() {
      let context = this;
      const api = "https://client.gig.co.ke/api/event/voting/report";
      const qs = require("qs");
      axios({
        method: "post",
        url: api,
        data: qs.stringify({
          eventid: "gev_1",
        }),
        headers: {
          "content-type": "application/x-www-form-urlencoded;charset=utf-8",
        },
      }).then((response) => {
        console.log(response);
        // context.$nextTick(() => {
        context.votes = response.data.data;
        // });
        context.$nextTick(() => {
      context.show = true;
    });
      });
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Open+Sans:400,400i,700");
* {
  margin: 0;
  padding: 0;
  outline: none;
  text-decoration: none;
  list-style: none;
  font-family: "Open Sans", sans-serif;
}

body {
  display: flex;
  align-items: center;
  justify-content: center;
  /* height: 100vh; */
  background: linear-gradient(-45deg, #ee7752, #e73c7e, #23a6d5, #23d5ab);
  margin: 100px;
  -webkit-animation: Gradient 15s ease infinite;
  -moz-animation: Gradient 15s ease infinite;
  animation: Gradient 15s ease infinite;
}

.list {
  width: 339px;
  height: 790px;
  padding-top: 20px;
  padding-bottom: 25px;
  background: #f7f9fd;
  border-radius: 35px;
}
.list .card {
  width: 309px;
  height: 132px;
  margin-left: 15.5px;
  margin-bottom: 2px;
  padding-top: 17px;
  border-radius: 8px;
  transition: 0.3s;
  cursor: pointer;
}
.list .card.active {
  background: #ffffff;
  box-shadow: 0px 5px 27px rgba(52, 87, 220, 0.131454);
  margin-top: 11px;
  margin-bottom: 10px;
}
.list .card:first-child {
  padding-bottom: 23px;
}
.list .card:hover {
  background: #ffffff;
  box-shadow: 0px 5px 27px rgba(52, 87, 220, 0.131454);
}
.list .card .chip {
  background: rgba(144, 207, 2, 0.1);
  border-radius: 12.5px;
  width: 106px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  margin-left: 13.5px;
  color: #202842;
  margin-bottom: 10px;
}
.list .card .chip.two {
  background: rgba(255, 163, 12, 0.2);
}
.list .card .chip.three {
  background: #f2dfe3;
}
.list .card h3 {
  font-family: Open Sans;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 22px;
  color: #202842;
  margin-left: 14px;
  margin-top: 10px;
  padding-bottom: 10px;
}
.list .card small {
  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  /* identical to box height */
  margin-left: 13.5px;
  margin-top: 10px;
  color: #5d698d;
}

.card-one {
  width: 100%;
  /* height: 327px; */
  padding-top: 35px;
  background: #ffffff;
  box-shadow: 0px 5px 27px rgba(52, 87, 220, 0.131454);
  border-radius: 5px;
  /* margin-left: 40px; */
}
.card-one h3 {
  margin-left: 50px;
  font-family: Open Sans;
  font-style: normal;
  font-weight: bold;
  font-size: 56px;
  line-height: 30px;
  color: #202842;
  margin-bottom: 45px;
}
.card-one .container {
  margin: 0 50px 0;
  margin-top: 20px;
  margin-bottom: 85px;
}
.card-one .container .topLabels {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.card-one .container .topLabels label {
  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 36px;
  line-height: 42px;
  color: #202842;
}
.card-one .container .progress {
  margin-top: 4px;
  margin-bottom: 4px;
  width: 100%;
  height: 26px;
  background: #f7f9fd;
  border-radius: 7.5px;
  overflow: hidden;
}
.card-one .container .progress .bar {
  height: 22px;
  /* width: 40%; */
  background: #202842;
  border-radius: 7.5px;
  margin-left: 3px;
  margin-top: 3px;
}

.card-one .container label {
  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 22px;
  line-height: 19px;
  color: #202842;
  margin-left: 2px;
}
.cont{
  font-size: 32px;
}

.bar{
  width: 0;
  transition: width 0.5s linear;
}
.cards {
  display: flex;
  justify-content: center;
  /* margin-left: 40px; */
  /* margin-top: 70px; */
}
.cards .card {
  /* width: 269px; */
  width:100%;
  height: 117px;
  background: #ffffff;
  border: 1px solid #f7f9fd;
  box-sizing: border-box;
  border-radius: 5px;
  margin-right: 15px;
  display: flex;
  align-items: center;
}
.cards .card .icon {
  width: 60px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 25px;
  margin-right: 17px;
  background: #eaefff;
  border-radius: 50%;
}
.cards .card .icon.two {
  background: #f9eaff;
}
.cards .card .icon.three {
  background: #ffeaef;
}
.cards .card .icon label {
  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 25px;
  /* identical to box height */
  color: #202842;
  margin-bottom: 4px;
}
.cards .card .icon h3 {
  font-family: Open Sans;
  font-style: normal;
  font-weight: bold;
  font-size: 28px;
  line-height: 38px;
  color: #202842;
}

@-webkit-keyframes Gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@-moz-keyframes Gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes Gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

h1,
h6 {
  font-family: "Open Sans";
  font-weight: 300;
  text-align: center;
  position: absolute;
  top: 45%;
  right: 0;
  left: 0;
}

.shake {
  animation: shake-animation 4.72s ease infinite;
  transform-origin: 50% 50%;
}
.element {
  margin: 0 auto;
  width: 150px;
  height: 150px;
  background: red;
}
@keyframes shake-animation {
  0% {
    transform: translate(0, 0);
  }
  1.78571% {
    transform: translate(5px, 0);
  }
  3.57143% {
    transform: translate(0, 0);
  }
  5.35714% {
    transform: translate(5px, 0);
  }
  7.14286% {
    transform: translate(0, 0);
  }
  8.92857% {
    transform: translate(5px, 0);
  }
  10.71429% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(0, 0);
  }
}

.backdrop {
  -moz-box-shadow: 0px 6px 5px #111;
  -webkit-box-shadow: 0px 6px 5px #111;
  box-shadow: 0px 2px 10px #111;
  -moz-border-radius: 190px;
  -webkit-border-radius: 190px;
  border-radius: 190px;
}
</style>

<!--end of poddium style -->
